const  createBrowserHistory = require("history").createBrowserHistory

const history = createBrowserHistory()
export default history;